import script from "./TreesCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./TreesCollection.vue?vue&type=script&setup=true&lang=js"

export default script